export const chromaEndpoint = "https://api.chroma.vision"
// export const chromaEndpoint = "http://localhost:3030"

export const chromaHeaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${window?.localStorage?.chroma_token}`
}